module.exports = __webpack_public_path__ + "img/mastercard.5857a686.svg";